var _circle, _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgNewNotesIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 42,
    height: 42,
    viewBox: "0 0 42 42",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 21,
    cy: 21,
    r: 21,
    fill: "#EBF9FF"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.625 10.5C13.5895 10.5 12.75 11.3395 12.75 12.375V29.625C12.75 30.6605 13.5895 31.5 14.625 31.5H27.375C28.4105 31.5 29.25 30.6605 29.25 29.625V21.75C29.25 19.6789 27.5711 18 25.5 18H23.625C22.5895 18 21.75 17.1605 21.75 16.125V14.25C21.75 12.1789 20.0711 10.5 18 10.5H14.625ZM16.5 24C16.5 23.5858 16.8358 23.25 17.25 23.25H24.75C25.1642 23.25 25.5 23.5858 25.5 24C25.5 24.4142 25.1642 24.75 24.75 24.75H17.25C16.8358 24.75 16.5 24.4142 16.5 24ZM17.25 26.25C16.8358 26.25 16.5 26.5858 16.5 27C16.5 27.4142 16.8358 27.75 17.25 27.75H21C21.4142 27.75 21.75 27.4142 21.75 27C21.75 26.5858 21.4142 26.25 21 26.25H17.25Z",
    fill: "#1A7FAE"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M21.9712 10.8159C22.768 11.7365 23.25 12.9369 23.25 14.25V16.125C23.25 16.3321 23.4179 16.5 23.625 16.5H25.5C26.8131 16.5 28.0135 16.982 28.9341 17.7788C28.0462 14.3799 25.3701 11.7038 21.9712 10.8159Z",
    fill: "#1A7FAE"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNewNotesIcon);
export default __webpack_public_path__ + "static/media/new-notes-icon.4f1efde8dbf9a897e691f9788016d7bb.svg";
export { ForwardRef as ReactComponent };